import { render, staticRenderFns } from "./expenseadmin.vue?vue&type=template&id=6d601918&scoped=true&"
import script from "./expenseadmin.vue?vue&type=script&lang=js&"
export * from "./expenseadmin.vue?vue&type=script&lang=js&"
import style0 from "./expenseadmin.vue?vue&type=style&index=0&id=6d601918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d601918",
  null
  
)

export default component.exports